import type { ReactNode } from 'react';
import { CheckCircle2, Clock, Loader2, XCircle } from 'lucide-react';

import { Badge } from 'components/ui/badge';
import { EmbeddedStatus } from 'features/chat/agent-chat-module/types/kb.service.type';
import { cn } from 'lib/utils';

type KbEmbedStatusProps = {
  status?: EmbeddedStatus;
  className?: string;
};

const statusConfig: Record<
  EmbeddedStatus,
  { label: string; icon: ReactNode; className: string }
> = {
  [EmbeddedStatus.COMPLETED]: {
    label: 'embedded',
    icon: <CheckCircle2 className="h-3.5 w-3.5" />,
    className: 'border-success-green/30 bg-success-green/10 text-success-green',
  },
  [EmbeddedStatus.PENDING]: {
    label: 'pending',
    icon: <Clock className="h-3.5 w-3.5" />,
    className: 'border-border bg-muted text-muted-foreground',
  },
  [EmbeddedStatus.PROCESSING]: {
    label: 'processing',
    icon: <Loader2 className="h-3.5 w-3.5 animate-spin" />,
    className: 'border-primary/30 bg-primary/10 text-primary',
  },
  [EmbeddedStatus.FAILED]: {
    label: 'failed',
    icon: <XCircle className="h-3.5 w-3.5" />,
    className: 'border-destructive/30 bg-destructive/10 text-destructive',
  },
};

export function KbEmbedStatus({ status, className }: KbEmbedStatusProps) {
  const config = status ? statusConfig[status] : statusConfig[EmbeddedStatus.PENDING];

  return (
    <Badge
      variant="outline"
      className={cn('gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium capitalize', config.className, className)}
    >
      {config.icon}
      {config.label}
    </Badge>
  );
}
